@if (showCheckbox()) {
  <div class="mt-3 flex h-10 w-full items-center overflow-hidden">
    <mat-checkbox
      (change)="onAcknowledgementChange($event)"
      [checked]="hasCurrentUserAcknowledged()"
      [disabled]="checkboxDisabled()"
    >
      {{ 'task-description-acknowledgement-panel.acknowledge-description' | translate }}
    </mat-checkbox>
  </div>
}
